<template>
  <v-container fluid tag="section" :class="item.show ? '' : 'py-0'">
    <base-material-dialog
      :title='`${item.type === 1 ? "合同终止" : "关闭工单"}`'
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='500'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-2" outlined>
                  <div class="my-1">{{item.data.customer.name}}</div>
                  <div class="my-1">{{item.data.serialNumber || item.data.orderNumber}}</div>
                  <div class="my-1"> {{item.data.product.name}}</div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea outlined  rows='3' :rules="required" v-model="form.remark" label="原因描述"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { update } from '@/api/contract/index.js'
  import { save } from '@/api/order/index.js'

  export default {
    name: 'Stop',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          type: 1,
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          id: '',
          stateId: '',
          orderStatus: 7,
          remark: ''
        },
        defForm: {
          id: '',
          stateId: '',
          orderStatus: 7,
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          if (this.item.type === 1) { // 合同终止
            update(this.form).then(res => {
              if (res.status === 200) {
                this.item.show = false
                this.$emit("on-load-data")
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          } else { // 工单终止
            save(this.form).then(res => {
              if (res.status === 200) {
                this.item.show = false
                this.$emit("on-load-data")
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          }
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form.id = this.item.data.id
            this.form.stateId = this.$constants.ContractState.STOP_AUDIT_ID
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    }
  }
</script>

<style>
</style>
